<template>
  <div style="margin-bottom: 150px">
    <Panel
      :class="'switch-off-notification'"
      :variant="['30-paddings', 'default', 'rounded']"
    >
      <label class="d-flex align-items-center mt-3">
        <Checkbox v-model="notifications" />
        <TextBlock class="h-ml-3">
          {{
            $t(
              '_web_tournament_auto-notify-label',
              'Switch off tournament related notifications'
            )
          }}
        </TextBlock>
      </label>
    </Panel>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { get } from '@/utils/lodashUtils';
import Panel from '@/components/atoms/Panel';
import Checkbox from '@/components/atoms/form/Checkbox';
import TextBlock from '@/components/atoms/TextBlock';

export default {
  name: 'TournamentRegistrationNotificationSetting',
  components: {
    Checkbox,
    TextBlock,
    Panel,
  },
  computed: {
    ...mapGetters(['currentTournament']),
    notifications: {
      get() {
        return get(this.currentTournament, 'skip_notifications', false);
      },
      set(newVal) {
        this.updateCurrentTournament({
          skip_notifications: newVal,
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
  },
};
</script>

<style lang="scss">
.switch-off-notification {
  padding: 17px !important;
}
</style>
